var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgToastError = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3.33325C10.8007 3.33325 3.33398 10.7999 3.33398 19.9999C3.33398 29.1999 10.8007 36.6666 20.0007 36.6666C29.2007 36.6666 36.6673 29.1999 36.6673 19.9999C36.6673 10.7999 29.2007 3.33325 20.0007 3.33325ZM21.6673 28.3333H18.334V24.9999H21.6673V28.3333ZM21.6673 21.6666H18.334V11.6666H21.6673V21.6666Z",
    fill: "#721C24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToastError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/toast-error.a469d6959a500bb9e80013d273ee475a.svg";